import React, { useContext } from 'react';
import './NotificationSection.scss';
import './TabletNotificationStyle.scss';
import { Image, Row, Loader } from '@thd-olt-component-react/core-ui';
import { handleTileAnalytics } from '../../common/utils/AnalyticsUtils';
import * as Constants from '../../core/Constants';
import { floorNumberWithCommas } from '../../common/utils/CurrencyUtils';
import { ProgressTracker } from '../../common/ProgressTracker/ProgressTracker';
import { getAccrualData, getHostCURL, getImageURL, isObjectEmpty } from '../../common/utils/cardUtils';

const analytics = Constants.analytics.NOTIFICATION;

const Arrow = () => (
  <Image className="arrow" width="12x" height="21px" src={getImageURL('caret-big.svg')} alt="caret-big" />
);

const ProgressPerk = ({ perkSummary }) => {
  const perkData = getAccrualData(perkSummary);
  const amountRequired = perkData?.spendForNextPerk
    ? perkData?.spendForNextPerk : 0;
  const amount = floorNumberWithCommas(amountRequired, 0);
  const percentage = parseInt(perkSummary?.perkCurrentTierProgressPercentage, 10);
  return (
    <a
      className="PromotionSection__moreBox"
      href={getHostCURL('/b2b/account/view/proXtraPerks')}
      rel=" noreferrer"
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.perkStatus)}
    >
      <div className="notification__logoWrapper">
        <div className="col__2-12 notification__circleBox">
          <div className="notification__progress"><ProgressTracker percentage={percentage} /></div>
        </div>
      </div>
      <div className="col__9-12 notification__label notification__trackerLabel">${amount} Until Your Next Perk
      </div>
      <div className="col__1-12 notification__hideArrow "><Arrow /></div>
    </a>
  );
};

const UnlockPerk = ({ perkSummary }) => {
  const { unclaimedPerksCount } = perkSummary;
  return (
    <a
      className="PromotionSection__moreBox"
      href={getHostCURL('/b2b/account/view/proXtraPerks')}
      rel=" noreferrer"
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.availablePerks)}
    >
      <div className="col__2-12 notification__logoWrapper">
        <div className="notification__logoContainer"><Image
          width="28px"
          height="28px"
          src={getImageURL('badge-unlocked.svg')}
          alt="badge-unlocked"
        />
        </div>
      </div>
      <div className="col__8-12 notification__label notification__unlockPerkLabel">New Unlocked Perk</div>
      <div className="col__2-12 notification__perkCount">
        <span className="notification__dot">{unclaimedPerksCount || 0}</span>
      </div>
    </a>
  );
};

const AvailablePerks = ({ availablePerksCount }) => {
  const { availablePerks } = availablePerksCount;
  return (
    <a
      className="PromotionSection__moreBox"
      href={getHostCURL('/b2b/account/view/proXtraPerks')}
      rel=" noreferrer"
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.availablePerks)}
    >
      <div className="col__2-12 notification__logoWrapper">
        <div className="notification__logoContainer"><Image
          width="25px"
          height="30px"
          src={getImageURL('pro-extra-perk.svg')}
          alt="pro-extra-perk"
        />
        </div>
      </div>
      <div className="col__9-12 notification__label notification__availablePerkLabel">Your Available Perks</div>
      <div className="col__1-12 notification__perkCount">
        <span className="notification__dot">{availablePerks || 0}</span>
      </div>
    </a>
  );
};

const WellDoneCard = ({ userProfile }) => {
  const { firstName } = userProfile.name;
  return (
    <a
      className="PromotionSection__moreBox"
      href={getHostCURL('/b2b/account/view/proXtraPerks')}
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.availablePerks)}
      rel=" noreferrer"
    >
      <div className="col__2-12 notification__logoWrapper">
        <div className="notification__logoContainer"><Image
          width="25px"
          height="30px"
          src={getImageURL('pro-extra-perk.svg')}
          alt="pro-extra-perk"
        />
        </div>
      </div>
      <div className="col__6-12 notification__label notification__availablePerkLabel">
        Well Done{firstName && `, ${firstName}`}!
      </div>
      <div className="col__4-12 notification__perkCount">
        <span className="PromotionSection__subLink">View Perks</span>
      </div>
    </a>
  );
};

const PerkExpireLabel = ({ availablePerksCount }) => {
  const { expiringPerks, daysLeft } = availablePerksCount;
  let expireLabel;
  if (expiringPerks > 1) {
    expireLabel = `Perks Expire in ${daysLeft || 0} Days`;
  } else {
    expireLabel = `Perk Expiring In ${daysLeft || 0} Days`;
  }
  return expireLabel;
};

const PerkExpire = ({ availablePerksCount }) => {
  return (
    <a
      className="PromotionSection__moreBox expireBox"
      href={getHostCURL('/b2b/account/view/proXtraPerks')}
      rel=" noreferrer"
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.availablePerks)}
    >
      <div className="col__2-12 notification__logoWrapper">
        <div className="notification__logoContainer"><Image
          width="25px"
          height="30px"
          src={getImageURL('warning-yellow.svg')}
          alt="warning-yellow"
        />
        </div>
      </div>
      <div className="col__9-12 notification__label notification__availablePerkLabel">
        <PerkExpireLabel availablePerksCount={availablePerksCount} />
      </div>
      <div className="col__1-12 notification__perkCount">
        <div className="notification__refresh">Redeem</div>
      </div>
    </a>
  );
};

const PerkExclusive = () => {
  const offersAmount = 1;
  return (
    <a
      className="PromotionSection__moreBox"
      href={getHostCURL('/b2b/account/view/proXtraPerks')}
      rel=" noreferrer"
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.availablePerks)}
    >
      <div className="col__2-12 notification__logoWrapper">
        <div className="notification__logoContainer"><Image
          width="26px"
          height="30px"
          src={getImageURL('WelcomeCard/ExclusiveOffers.svg')}
          alt="ExclusiveOffers"
        />
        </div>
      </div>
      <div className="col__9-12 notification__label"> Pro Xtra Exclusive Offers</div>
      <div className="col__1-12 notification__perkCount notification__proExtraCount">
        <span className="notification__dot">{offersAmount || 0}</span>
      </div>
    </a>
  );
};

const PreferredUnlocked = () => {
  return (
    <a
      className="PromotionSection__moreBox"
      href={getHostCURL('/b2b/account/view/proXtraPricing')}
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.pricingUnlocked)}
      rel=" noreferrer"
    >
      <div className="col__2-12 notification__logoWrapper">
        <div className="notification__logoContainer"><Image
          width="28.39px"
          height="25.45px"
          src={getImageURL('WelcomeCard/PP_RGB_Orange-Black.svg')}
          alt="PP_RGB_Orange-Black"
        />
        </div>
      </div>
      <div className="col__9-12 notification__label"> Preferred Pricing Unlocked</div>
      <div className="col__1-12 notification__hideArrow "><Arrow /></div>
    </a>
  );
};

const ProCreditCard = ({ perkSummary }) => {
  const perkData = perkSummary ? getAccrualData(perkSummary) : null;
  const amountRequired = perkData?.spendForNextPerkWithPxcc
    ? perkData?.spendForNextPerkWithPxcc : 0;
  const amount = floorNumberWithCommas(amountRequired, 0);
  const factor = perkSummary?.activePxccFactor ? perkSummary?.activePxccFactor : 4;
  return (
    <a
      className="PromotionSection__moreBox"
      href={getHostCURL('/b2b/account/view/proXtraPerks')}
      rel=" noreferrer"
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.perkStatus)}
    >
      <div className="col__2-12 notification__logoWrapper">
        <div className="notification__logoPLCCContainer">
          <div className="notification__inner-circle">{factor}X</div>
          <Image
            className="notification__creditCardLogo"
            src={getImageURL('cardPLCCX.png')}
            alt="cardPLCCX"
          />
        </div>
      </div>
      <div className="col__9-12 notification__PLCClabel notification__plcc">
        <div className="notification__labelPLCC">${amount} Until Next Perk</div>
        <div className="notification__labelPLCC">with Pro Xtra Credit Card</div>
      </div>
      <div className="col__1-12 notification__plCCArrow"><Arrow /></div>
    </a>
  );
};

const PaintMemberLabel = ({ currentPaintLevel }) => {
  let paintLevel;
  if (currentPaintLevel === 'Bronze') {
    paintLevel = 'Save 10% on paint products';
  } else if (currentPaintLevel === 'Silver') {
    paintLevel = 'Save 15% on paint products';
  } else if (currentPaintLevel === 'Gold') {
    paintLevel = 'Save 20% on paint products';
  } else {
    paintLevel = 'Close to Unlocking Paint Rewards';
  }
  return paintLevel;
};

const PaintMemberProducts = ({ currentPaintLevel }) => {
  let paintImage;
  if (currentPaintLevel === 'Bronze') {
    paintImage = 'paint-rewards-bronze.svg';
  } else if (currentPaintLevel === 'Silver') {
    paintImage = 'paint-rewards-silver.svg';
  } else if (currentPaintLevel === 'Gold') {
    paintImage = 'paint-rewards-gold.svg';
  } else {
    paintImage = 'paint-rewards-white.svg';
  }
  return (
    <a
      className="PromotionSection__moreBox"
      href={getHostCURL('/b2b/account/view/proXtraPricing')}
      rel=" noreferrer"
      onClick={() => handleTileAnalytics(analytics.PREFIX, analytics.pricingUnlocked)}
    >
      <div className="col__2-12 notification__logoWrapper">
        <div className="frame notification__paintIconWrapper">
          <Image className="paintImage" src={getImageURL(paintImage)} alt="paintImage" />
        </div>
      </div>
      <div className="col__9-12 notification__label notification__paintLabel">
        <PaintMemberLabel currentPaintLevel={currentPaintLevel} />
      </div>
      <div className="col__1-12 notification__hideArrow notification__paintArrow"><Arrow /></div>
    </a>
  );
};

const PerkStatusUnavailable = ({ error: err, isLoadingPerks, refreshAvailablePerks }) => {
  const refreshLoading = !isLoadingPerks;
  return (
    <div className="PromotionSection__moreBox">
      <div className="col__2-12 notification__logoWrapper">
        <div className="notification__logoContainer"><Image
          width="25px"
          height="30px"
          src={getImageURL('pro-extra-perk.svg')}
          alt="pro-extra-perk"
        />
        </div>
      </div>
      <div className="col__8-12 notification__refreshLabel">{refreshLoading ? 'Perks Status Unavailable'
        : <span className="notification__loadingLabel">Loading Perks Status</span>}
      </div>
      <div className="col__2-12 notification__perkCount">
        {refreshLoading
          ? <div className="notification__refresh" aria-hidden="true" onClick={refreshAvailablePerks}>Refresh</div>
          : <span className="notification__loaderWrapper"><Loader active small /></span>}
      </div>
    </div>
  );
};

export const showingTileNotifications = ({ isAdmin, userData, availablePerksData }) => {
  const { customerInfo, perkSummary } = userData || {};
  const { activePerksCount } = perkSummary || {};
  const accrualData = getAccrualData(perkSummary);
  const proXtraCCProgram = perkSummary?.pxccUserCategory === 'Enrolled';
  const showRenderPerks = isAdmin && !isObjectEmpty(accrualData) && ((perkSummary?.unclaimedPerksCount > 0)
    || (!accrualData?.finalTierPerkAchieved && proXtraCCProgram)
    || (accrualData?.finalTierPerkAchieved)
    || availablePerksData !== undefined
    || activePerksCount);

  const showEnrollmentPrograms = (customerInfo?.enrolledInPreferredPricing && !customerInfo?.preferredPricingTierZero);

  const showingTile = {
    RenderPerksProgress: showRenderPerks,
    PerkExclusive: showEnrollmentPrograms,
    EnrollmentPrograms: true,
  };
  return showingTile;
};

export const prioritizedListNotifications = ({
  showingTile, userData, availablePerksData, isLoadingPerks, refreshAvailablePerks, availablePerksError
}) => {
  const { customerInfo, perkSummary, userProfile } = userData || {};
  const proXtraCCProgram = perkSummary?.pxccUserCategory === 'Enrolled';
  const { activePerksCount } = perkSummary || {};
  const currentPaintLevel = customerInfo?.paintMembershipLevel ? customerInfo?.paintMembershipLevel : 'Member';
  const accrualData = getAccrualData(perkSummary);
  const RenderPerksProgress = () => {
    const finalTierPerkAchieved = accrualData[0]?.finalTierPerkAchieved;
    const { unclaimedPerksCount } = perkSummary || {};
    const data = availablePerksData;
    const error = !availablePerksData || isObjectEmpty(availablePerksData) || availablePerksError;

    /* How can we utilize state here? Have the refresh reset the entire renderperksprogress? */
    let availablePerksCount;
    if (finalTierPerkAchieved && !activePerksCount && unclaimedPerksCount < 1) {
      return <WellDoneCard userProfile={userProfile} />;
    }

    if (activePerksCount && (isLoadingPerks || error)) {
      return (
        <PerkStatusUnavailable
          isLoadingPerks={isLoadingPerks}
          refreshAvailablePerks={refreshAvailablePerks}
        />
      );
    }

    // State 5
    if (activePerksCount && !isLoadingPerks && data) {
      availablePerksCount = data;
      if (availablePerksCount?.expiringPerks > 0) {
        return <PerkExpire availablePerksCount={availablePerksCount} />;
      }
    }

    // State 4
    if (unclaimedPerksCount > 0) {
      return <UnlockPerk perkSummary={perkSummary} />;
    }

    // State 3
    if (activePerksCount && !isLoadingPerks && data) {
      if (availablePerksCount?.availablePerks > 0) {
        return <AvailablePerks availablePerksCount={availablePerksCount} />;
      }
    }

    // State 2
    if (!finalTierPerkAchieved && proXtraCCProgram) {
      return <ProCreditCard perkSummary={perkSummary} />;
    }

    // State 1
    if (!finalTierPerkAchieved && !proXtraCCProgram) {
      return <ProgressPerk perkSummary={perkSummary} />;
    }

    return (
      <PerkStatusUnavailable
        error={error}
        isLoadingPerks={isLoadingPerks}
        refreshAvailablePerks={refreshAvailablePerks}
      />
    );
  };

  const EnrollmentPrograms = () => {
    if (customerInfo?.enrolledInPreferredPricing && !customerInfo?.preferredPricingTierZero) {
      return <PreferredUnlocked />;
    }
    return <PaintMemberProducts currentPaintLevel={currentPaintLevel} />;
  };

  const prioritizedList = [
    showingTile.RenderPerksProgress && <RenderPerksProgress />,
    // showingTile.PerkExclusive && <PerkExclusive />,
    showingTile.EnrollmentPrograms && <EnrollmentPrograms />,
  ];

  return prioritizedList;
};

const NotificationSection = ({ tiles }) => {
  const DisplayTiles = () => tiles;

  const renderCustomStyle = () => {
    const notification = tiles?.filter(Boolean)?.length;
    if (notification === 1) {
      return 'notification__tablet notification__one';
    } if (notification === 2) {
      return 'notification__tablet notification__two';
    } if (notification === 3) {
      return 'notification__tablet notification__three';
    }
    return 'notification__tablet notification__more';
  };

  return (
    <Row className={renderCustomStyle()}>
      <DisplayTiles />
    </Row>
  );
};

export const exportsForTesting = {
  ProgressPerk,
  UnlockPerk,
  AvailablePerks,
  WellDoneCard,
  PerkExpire,
  PreferredUnlocked,
  ProCreditCard,
  PaintMemberProducts,
  PerkStatusUnavailable,
  PerkExclusive,
};

export default NotificationSection;